"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactUse = require("react-use");

var ProductSidebar = function ProductSidebar(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      header = _ref.header,
      _ref$wrapperProps = _ref.wrapperProps,
      wrapperProps = _ref$wrapperProps === void 0 ? {} : _ref$wrapperProps,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 496 : _ref$width;

  var _useWindowSize = (0, _reactUse.useWindowSize)(),
      clientWidth = _useWindowSize.width;

  return /*#__PURE__*/_react["default"].createElement(_material.Drawer, {
    disableEnforceFocus: true,
    className: "sidebarDrawer-ie",
    open: isOpen,
    anchor: "right",
    onClose: onClose,
    disablePortal: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    width: [clientWidth, width],
    height: "auto"
  }, wrapperProps), header, isOpen && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    height: 1
  }, children)));
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductSidebar);

exports["default"] = _default;